import keywords from './keywords.jsx';
import commons from './commons.jsx';

//pages
import asset from './pages/asset';
import collections from './pages/collections';
import conversations from './pages/conversations';
import hub from './pages/hub';
import reports from './pages/reports';
import search from './pages/search';
import seek from './pages/seek';
import settings from './pages/settings';
import engage from './pages/engage';
import dealInsights from "./pages/dealInsight.jsx";


//components
import menuBar from './components/menuBar';
import addAsset from './components/addAsset';
import addBanner from './components/addBanner';
import compose from './components/compose';
import generateLink from './components/generateLink';
import contentMap from './components/contentMap';
import integrations from './components/integrations';

//constants
import contentTypes from './constants/contentTypes.jsx';
import layoutTypes from './constants/layoutTypes.jsx';
import smartFilters from './constants/smartFilters.jsx';
import userAccesses from './constants/userAccesses.jsx';
import accountSettings from './constants/accountSettings.jsx';
import integrationsOnboarding from './constants/integrationsOnboarding.jsx';

const en = {
  keywords: keywords,
  commons: commons,
  pages: {
    asset,
    collections,
    conversations,
    hub,
    reports,
    search,
    seek,
    settings,
    engage,
    dealInsights
   
  },
  components: {
    addAsset,
    addBanner,
    compose,
    generateLink,
    integrations,
    menuBar,
    contentMap
  },
  constants: {
    contentTypes,
    layoutTypes,
    smartFilters,
    userAccesses,
    accountSettings,
    integrationsOnboarding
  }
}

export default en;